export const tourProfileData = [
    {
        link: 'https://www.facebook.com/',
        icon: 'fa fa-facebook'
    },
    {
        link: 'https://accounts.google.com/',
        icon: 'fa fa-google-plus'
    },
    {
        link: 'https://twitter.com/',
        icon: 'fa fa-twitter'
    },
    {
        link: 'https://www.instagram.com/',
        icon: 'fa fa-instagram'
    },
    {
        link: 'https://rss.app/',
        icon: 'fa fa-rss'
    }
]

export const profileLikeData = [
    {
        class: 'list-inline-item b-r-gray pe-3',
        icon: 'fa fa-heart',
        text: <>&nbsp;&nbsp;Like</>,
        number:1807
    },
    {
        class: 'list-inline-item b-r-gray pe-3',
        icon: 'fa fa-comment',
        text: <>&nbsp;&nbsp;Comment</>,
        number:386
    }
]

export const addProjectsAndUploadData = [
    {
      date: "28 May 2023",
      status: "Completed",
      statusClass: "bg-success",
      price: "$56,908",
    },
    {
      date: "12 June 2023",
      status: "On going",
      statusClass: "bg-danger",
      price: "$45,087",
    },
    {
      date: "12 July 2023",
      status: "Pending",
      statusClass: "bg-warning",
      price: "$60,123",
    },
    {
      date: "14 June 2023",
      status: "Pending",
      statusClass: "bg-warning",
      price: "$70,435",
    },
    {
      date: "25 June 2023",
      status: "Completed",
      statusClass: "bg-success",
      price: "$15,987",
    },
    {
      date: "25 June 2023",
      status: "Completed",
      statusClass: "bg-success",
      price: "$15,987",
    },
  ];